module.exports = __webpack_public_path__ + "static/img/DOB-Energy-Logo-RGB_Horizontal-Colour-geoLOGIC-Tag-left.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DOB-Energy-Logo-RGB_Horizontal-Colour-geoLOGIC-Tag-left.png
// module id = 290
// module chunks = 1